var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentDiv',[_c('PageTitle',{staticClass:"secondary--text"},[_vm._v("Error")]),_c('p',[_vm._v("Page Not Found")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }